import { TextField, useTheme } from '@mui/material';

interface FilterTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  hasValue?: boolean;
}

const FilterTextField = ({ label, value, onChange, hasValue }: FilterTextFieldProps) => {
  const theme = useTheme();

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={e => onChange(e.target.value)}
      size="small"
      margin="dense"
      InputLabelProps={{
        shrink: true,
        sx: {
          fontSize: '0.75rem',
          color: hasValue ? theme.palette.primary.main : undefined,
          fontWeight: hasValue ? 600 : 400,
        },
      }}
      inputProps={{ sx: { fontSize: '0.75rem' } }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: hasValue ? theme.palette.primary.light + '20' : 'transparent', // Adding opacity
          '& fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
            borderWidth: hasValue ? '2px' : '1px',
          },
          '&:hover fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
          },
          '&.Mui-focused fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
          },
        },
      }}
    />
  );
};

export default FilterTextField;
